module.exports = __webpack_public_path__ + "img/п.7.251b5f1f.png";